module.exports = __webpack_public_path__ + "images/map-0cae0de4ca496e5df18ca1b704e162ec.jpg";